export const PROFILE_SECTION_TEST_IDS = {
  COMPLETE_PROFILE_TITLE: 'complete-profile-title',
  COMPLETE_MISSING_STEPS: 'complete-missing-steps',

  CURRENT_SUBSCRIPTIONS_CONTAINER: 'current-subscriptions-container',
  COMPLETE_PROFILE_CLOSE_BUTTON: 'complete-profile-button',

  CURRENT_SUBSCRIPTIONS_LABEL: 'current-subscriptions-label',
  COMPLETE_PROFILE_PERCENT: 'complete-profile-percent',
  FORM_ERROR_COUNTRY: 'form-error-country',

  FORM_ERROR_EMAIL: 'form-error-email',
  FORM_ERROR_EXPERIENCE_LEVEL: 'form-error-experience-level',
  FORM_ERROR_FIRST_NAME: 'form-error-first-name',

  FORM_ERROR_INDUSTRY: 'form-error-industry',
  FORM_ERROR_JOB_FUNCTION: 'form-error-job-function',
  FORM_ERROR_LAST_NAME: 'form-error-last-name',
  FORM_ERROR_SALUTATION: 'form-error-salutation',

  MOBILE_BACK_BUTTON: 'mobile-back-button',
  MOBILE_EDIT_BUTTON: 'mobile-edit-button',
  MOBILE_SAVE_BUTTON: 'mobile-save-button',

  MY_PROFILE_HEADER: 'my-profile-header',
  MY_PROFILE_WRAPPER: 'my-profile-wrapper',
  PERSONAL_INFO_CONTAINER: 'personal-info-container',

  PERSONAL_INFO_FIELD_CHANGE_PASSWORD: 'personal-info-field-change-password',
  PERSONAL_INFO_FIELD_COUNTRY: 'personal-info-field-country',
  PERSONAL_INFO_FIELD_COUNTRY_INPUT: 'personal-info-field-country-input',

  PERSONAL_INFO_FIELD_COUNTRY_PARAGRAPH: 'personal-info-field-country-paragraph',
  PERSONAL_INFO_FIELD_EMAIL: 'personal-info-field-email',
  PERSONAL_INFO_FIELD_EMAIL_INPUT: 'personal-info-field-email-input',

  PERSONAL_INFO_FIELD_EMAIL_PARAGRAPH: 'personal-info-field-email-paragraph',
  PERSONAL_INFO_FIELD_EXPERIENCE_LEVEL: 'personal-info-field-experience-level',
  PERSONAL_INFO_FIELD_EXPERIENCE_LEVEL_INPUT: 'personal-info-field-experience-level-input',

  PERSONAL_INFO_FIELD_EXPERIENCE_LEVEL_PARAGRAPH: 'personal-info-field-experience-level-paragraph',
  PERSONAL_INFO_FIELD_FIRST_NAME: 'personal-info-field-first-name',
  PERSONAL_INFO_FIELD_FIRST_NAMEI_INPUT: 'personal-info-field-first-name-input',

  PERSONAL_INFO_FIELD_FIRST_NAME_PARAGRAPH: 'personal-info-field-first-name-paragraph',
  PERSONAL_INFO_FIELD_INDUSTRY: 'personal-info-field-industry',
  PERSONAL_INFO_FIELD_INDUSTRY_INPUT: 'personal-info-field-industry-input',

  PERSONAL_INFO_FIELD_INDUSTRY_PARAGRAPH: 'personal-info-field-industry-paragraph',
  PERSONAL_INFO_FIELD_JOB_FUNCTION: 'personal-info-field-job-function',
  PERSONAL_INFO_FIELD_JOB_FUNCTION_INPUT: 'personal-info-field-job-function-input',

  PERSONAL_INFO_FIELD_JOB_FUNCTION_PARAGRAPH: 'personal-info-field-job-function-paragraph',
  PERSONAL_INFO_FIELD_LAST_NAME: 'personal-info-field-last-name',
  PERSONAL_INFO_FIELD_LAST_NAME_INPUT: 'personal-info-field-last-name-input',
  PERSONAL_INFO_FIELD_LAST_NAME_PARAGRAPH: 'personal-info-field-last-name-paragraph',
  PERSONAL_INFO_FIELD_MODAL_PASSWORD: 'personal-info-field-modal-password',

  PERSONAL_INFO_FIELD_OPT_IN_VIEW: 'personal-info-field-opt-in-view',
  PERSONAL_INFO_FIELD_OPT_IN_VIEW_CHECKBOX: 'personal-info-field-opt-in-view-checkbox',

  PERSONAL_INFO_FIELD_PASSWORD: 'personal-info-field-password',
  PERSONAL_INFO_FIELD_PASSWORD_INPUT: 'personal-info-field-password-input',
  PERSONAL_INFO_FIELD_PASSWORD_PARAGRAPH: 'personal-info-field-password-paragraph',
  PERSONAL_INFO_FIELD_SALUTATION: 'personal-info-field-salutation',
  PERSONAL_INFO_FIELD_SALUTATION_INPUT: 'personal-info-field-salutation-input',
  PERSONAL_INFO_FIELD_SALUTATION_PARAGRAPH: 'personal-info-field-salutation-paragraph',
  PERSONAL_INFO_HEADER: 'personal-info-header',
  PERSONAL_INFO_WRAPPER: 'personal-info-wrapper',

  PIANO_RESOURCE: 'piano-resource',
  PROFILE_COMPLETION_BAR_ICON: 'profile-completion-bar-icon',

  PROFILE_COMPLETION_HEADER: 'profile-completion-header',
  PROFILE_COMPLETION_ICONS: 'profile-completion-icons',
  PROFILE_COMPLETION_STATUS_BAR: 'profile-completion-status-bar',
  PROFILE_COMPLETION_STATUS_CONTAINER: 'profile-completion-status-container',

  PROFILE_SUMMARY_CONTAINER: 'profile-summary-container',
  RENEW_LINK: 'renew-link',
  SUBSCRIPTION_STATUS: 'subscription-status',
  TOP_LABELS_CONTAINER: 'top-labels-container',
  USER_CARD_TITLE: 'user-card-title',
};

export const MY_ACCOUNT_MENU_TEST_IDS = {
  CUSTOMER_SUPPORT_LINK: 'customer-support-link',
  CUSTOMER_SUPPORT_TEXT: 'customer-support-text',
  CUSTOMER_SUPPORT_TITLE: 'customer-support-title',
  CUSTOMER_SUPPORT_WRAPPER: 'customer-support-wrapper',

  MENU_ITEMS_CUSTOMER_SUPPORT: 'menu-items-customer-support',
  MENU_ITEMS_WRAPPER: 'menu-items-wrapper',
  MENU_ITEM_WRAPPER: 'menu-item-wrapper',

  MY_ACCOUNT_TITLE: 'my-account-title',
};
